import { gql } from "@apollo/client";


export const ADD_SCHEDULE = gql`
mutation AddCampaignSchedule($campaignScheduleInput: CampaignScheduleInput!) {
  addCampaignSchedule(campaignScheduleInput: $campaignScheduleInput) {
    campaignId
    campaignName
    schedule {
      _id
      delayInterval
      scheduleDays
      scheduleEndTime
      scheduleName
      scheduleStartTime
      scheduleTimeZone
      scheduleTimeZoneName
    }
  }
}
`

export const GET_SCHEDULED_DATA = gql`
mutation GetCampaignSchedule($campaignId: String!) {
  getCampaignSchedule(campaignId: $campaignId) {
    campaignId
    campaignName
    schedule {
      _id
      delayInterval
      scheduleDays
      scheduleEndTime
      scheduleName
      scheduleStartTime
      scheduleTimeZone
      scheduleTimeZoneName
    }
  }
}
`